import ApiService from '../services/ApiService';
import * as types from './ActionTypes';

export const addImageCaptcha = image => ({
  type: types.ADD_IMAGE_CAPTCHA,
  payload: {
    image,
  },
  clickedAt: Date.now(),
});

export const removeLastImageCaptcha = () => ({
  type: types.REMOVE_LAST_IMAGE_CAPTCHA,
  clickedAt: Date.now(),
});

const clearCaptcha = () => ({
  type: types.CLEAR_CAPTCHA,
  executedAt: Date.now(),
});

const createCaptcha = () => ({
  type: types.CREATE_CAPTCHA,
  requestAt: Date.now(),
});

const createCaptchaSuccess = captcha => ({
  type: types.CREATE_CAPTCHA_SUCCESS,
  payload: {
    images: captcha.rows,
    indications: captcha.indications,
  },
  receiveAt: Date.now(),
});

const createCaptchaFailure = error => ({
  type: types.CREATE_CAPTCHA_FAILURE,
  error,
  receiveAt: Date.now(),
});

export const invalidCaptcha = () => ({
  type: types.INVALID_CAPTCHA,
  receiveAt: Date.now(),
});

export const notFinishedCaptcha = () => ({
  type: types.NOT_FINISHED_CAPTCHA,
  receiveAt: Date.now(),
});

/**
 * Thunk action to generate a captcha input if the service is available
 * @return {const(*): *}
 */
export const generateCaptcha = () => ((dispatch) => {
  dispatch(clearCaptcha());
  dispatch(createCaptcha());
  return ApiService.createCaptcha()
    .then(
      (res) => {
        const { data } = res.data;
        dispatch(createCaptchaSuccess(data));
      },
      (err) => {
        const { response } = err;
        dispatch(createCaptchaFailure(response));
      },
    );
});
